<template>
    <v-simple-table>
    <template v-slot:default>
        <thead>
        <tr>
            <th class="text-left">{{ $t('fields.property') }}</th>
            <th class="text-left">{{ $t('fields.value') }}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in statistics" :key="item">
            <td>{{ $t(`fields.${item.label}`) }}</td>
            <td>{{ item.value }}</td>
        </tr>
        </tbody>
    </template>
    </v-simple-table>
</template>

<script>
  import { mapActions } from 'vuex';

  import { propagandistsService } from '../../../utils/services/propagandists.service';

  export default {
    name: 'PropagandistStatisticDetails',
    components: {

    },
    props: {
      propagandist: {
        type: Object,
        default: () => {},
      },
    },
    data() {
        return {
            statistics: [],
        };
    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('alert', ['showToast']),
      fetchStatistics() {
        return propagandistsService.getStatistics(this.propagandist.id)
            .then((response) => {
                this.statistics = response.data.data;
            });
      },
    },
    created() {
        this.fetchStatistics();
    },
  };
</script>
